/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BulkBacksolveUpdate = {
  metric: BulkBacksolveUpdate.metric;
  adjustment_selected: BulkBacksolveUpdate.adjustment_selected;
  as_of_date?: string | null;
  opm_backsolve_date?: string | null;
  max_percent_change: string;
  min_percent_change: string;
  adjustment_type_selection: BulkBacksolveUpdate.adjustment_type_selection;
};
export namespace BulkBacksolveUpdate {
  export enum metric {
    MARKET_CAP = 'Market Cap',
    ENTERPRISE_VALUE = 'Enterprise Value',
    LTM_REVENUE = 'LTM Revenue',
    LTM_EBITDA = 'LTM EBITDA',
    NTM_REVENUE = 'NTM Revenue',
    NTM_EBITDA = 'NTM EBITDA',
    SHARE_PRICE = 'Share Price',
  }
  export enum adjustment_selected {
    MEDIAN = 'Median',
    MEAN = 'Mean',
    _75TH_PERCENTILE = '75th Percentile',
    _25TH_PERCENTILE = '25th Percentile',
    SELECTION_A = 'Selection A',
    SELECTION_B = 'Selection B',
    SPECIFIED = 'Specified',
  }
  export enum adjustment_type_selection {
    ENTERPRISE_VALUE = 'Enterprise Value',
    EQUITY_VALUE = 'Equity Value',
  }
}

